// copied from: https://github.com/wix-private/ecom/blob/ea1925c089cd4b4dfb25323f110de6b693865137/client/wixstores-client/wixstores-client-core/src/a11y/focus-ring.ts
import classList from 'dom-classlist';

export class FocusRing {
  public focusRingClass;
  public focusRingDataAdded;
  public elWithFocusRing;
  public keyboardNavigationActive;

  constructor(focusRingClass = 'focus-ring') {
    this.focusRingClass = focusRingClass;
    this.focusRingDataAdded = `data-${focusRingClass}-added`;
    this.keyboardNavigationActive = false;
  }

  private addFocusRingClass(el) {
    if (classList(el).contains(this.focusRingClass)) {
      return;
    }
    classList(el).add(this.focusRingClass);
    el.setAttribute(this.focusRingDataAdded, '');
  }

  private removeFocusRingClass(el) {
    if (!el.hasAttribute(this.focusRingDataAdded)) {
      return;
    }
    classList(el).remove(this.focusRingClass);
    el.removeAttribute(this.focusRingDataAdded);
  }

  private onKeyUp(e) {
    if (e.altKey || e.ctrlKey || e.metaKey) {
      return;
    }

    if ([9, 38, 40].indexOf(e.keyCode) !== -1) {
      const target = e.target;
      this.keyboardNavigationActive = true;
      this.addFocusRingClass(target);
    }
  }

  private onMouseUp() {
    this.keyboardNavigationActive = false;
  }

  private onBlur(e) {
    if (e.target === document) {
      return;
    }

    this.removeFocusRingClass(e.target);
  }

  private onWindowFocus() {
    // When removing the activeElement from DOM it's possible IE11 is in state
    // document.activeElement === null
    if (!document.activeElement) {
      return;
    }
    if (document.activeElement === this.elWithFocusRing) {
      this.addFocusRingClass(this.elWithFocusRing);
    }
    this.elWithFocusRing = null;
  }

  /**
   * When switching windows, keep track of the focused element if it has a
   * focus-ring class.
   */
  private onWindowBlur() {
    // When removing the activeElement from DOM it's possible IE11 is in state
    // document.activeElement === null
    if (!document.activeElement) {
      return;
    }
    if (classList(document.activeElement).contains(this.focusRingClass)) {
      // Keep a reference to the element to which the focus-ring class is applied
      // so the focus-ring class can be restored to it if the window regains
      // focus after being blurred.
      this.elWithFocusRing = document.activeElement;
    }
  }

  public init() {
    document.addEventListener('mouseup', () => this.onMouseUp.call(this), true);
    document.addEventListener('keyup', (e) => this.onKeyUp.call(this, e), true);
    document.addEventListener('blur', (e) => this.onBlur.call(this, e), true);
    window.addEventListener('focus', () => this.onWindowFocus.call(this), true);
    window.addEventListener('blur', () => this.onWindowBlur.call(this), true);
  }

  public focus(el) {
    if (this.keyboardNavigationActive) {
      classList(el).add(this.focusRingClass);
    }
    el.focus();
  }
}
